import http from '../../../../http/base';
import { API_PATHS } from '../../../../http/configs';

export default {
    getFacilitiesForMap: () => http.get(API_PATHS.getFacilitiesForMap)
};